export enum QueueTab {
    ONE_OFF_VISIT_REQUESTS,
    NEED_SERVICES,
    NEED_CLINICIANS,
    NEED_TENTATIVE_DATE,
    READY_FOR_PROMOTION,
    FULFILLED,
    CANCELED,
}
